import comp from "./LoginView";
export default comp;
